/**
 * Words for the 1-5 mood the evening review records, so the API can send the
 * number and every screen that shows it says the same thing about it. The same
 * rule the alignment bands follow.
 *
 * The scale comes from `COACHING_FEELING_MOOD`: frustrated 1, tired and
 * stressed 2, neutral 3, calm 4, happy and energized 5. The bands are placed at
 * the midpoints so a single day lands on the word for the feeling that was
 * actually chosen.
 */

export const MOOD_BANDS = ['Low', 'Mixed', 'Steady', 'Good', 'Strong'] as const;
export type MoodBand = (typeof MOOD_BANDS)[number];

/** The word for a mood between 1 and 5, or for an average of several. */
export function moodBand(value: number): MoodBand {
  if (value >= 4.5) return 'Strong';
  if (value >= 3.5) return 'Good';
  if (value >= 2.5) return 'Steady';
  if (value >= 1.5) return 'Mixed';
  return 'Low';
}

/** How many days out of `total` carry a mood, said plainly. */
export function moodCoverage(recorded: number, total: number): string {
  if (recorded === 0) return `No evening reviews in the last ${total} days`;
  if (recorded === total) return `Every one of the last ${total} days`;
  return `${recorded} of the last ${total} days`;
}
